<template>
  <div :class="{ sidebar: true, collapsed: !$root.sidebarExpanded, expanding: isExpanding}">
    <button
      type="button"
      :class="{ closeIcon: true, collapsed: !$root.sidebarExpanded}"
      :disabled="isExpanding"
      @click="toggleSidebar"
    >
      <font-awesome-icon icon="chevron-left" v-if="$root.sidebarExpanded"/>
      <font-awesome-icon icon="chevron-right" v-if="!$root.sidebarExpanded"/>
    </button>
    <div>
      <div class="logo">
        <img src="/images/ABG logo.png" />
      </div>

      <div class="header">
        <h1 class="title">
          <span>{{ $t('layout.sidebar.appName[0]') }}</span>
          <span>{{ $t('layout.sidebar.appName[1]') }}</span>
        </h1>
      </div>

      <div class="linkGroup">
        <h3 class="categoryTitle">
          {{ $t('layout.sidebar.headingNavigation') }}
        </h3>
        <ul class="links">
          <li>
            <a
              href="/"
              :class="{ link: true, active: isActive('/') }"
            >
              <span class="linkIcon">
                <font-awesome-icon icon="house"/>
              </span>
              <span class="linkText">
                {{ $t('layout.sidebar.linksNavigation.home') }}
              </span>
            </a>
          </li>
        </ul>
        <h3 class="categoryTitle">
          {{ $t('layout.sidebar.headingOrders') }}
        </h3>
        <ul class="links">
          <li>
            <a
              href="/nowe-zgloszenie"
              :class="{ link: true, active: isActive('/nowe-zgloszenie') }"
            >
              <span class="linkIcon">
                <font-awesome-icon icon="plus"/>
              </span>
              <span class="linkText">
                {{ $t('layout.sidebar.linksNavigation.create') }}
              </span>
            </a>
          </li>
          <li v-if="['abg_manager', 'abg_user'].includes(user.role)">
            <a
              href="/nieprzypisane-zgloszenia"
              :class="{ link: true, active: isActive('/nieprzypisane-zgloszenia') }"
            >
              <span class="linkIcon">
                <font-awesome-icon icon="user-slash"/>
              </span>
              <span class="linkText">
                {{ $t('layout.sidebar.linksNavigation.orderListUnassigned') }}
              </span>
            </a>
          </li>
          <li v-if="['client_manager', 'client_user'].includes(user.role)">
            <a
              href="/do-potwierdzenia"
              :class="{ link: true, active: isActive('/do-potwierdzenia') }"
            >
              <span class="linkIcon">
                <font-awesome-icon icon="check"/>
              </span>
              <span class="linkText">
                {{ $t('layout.sidebar.linksNavigation.orderListAwaitingAcceptance') }}
              </span>
            </a>
          </li>
          <li>
            <a
              href="/moje-zgloszenia"
              :class="{ link: true, active: isActive('/moje-zgloszenia') }"
            >
              <span class="linkIcon">
                <font-awesome-icon icon="user"/>
              </span>
              <span class="linkText">
                {{ $t('layout.sidebar.linksNavigation.orderListUser') }}
              </span>
            </a>
          </li>
          <li>
            <a
              href="/wszystkie-zgloszenia"
              :class="{ link: true, active: isActive('/wszystkie-zgloszenia') }"
            >
              <span class="linkIcon">
                <font-awesome-icon icon="list"/>
              </span>
              <span class="linkText">
                {{ $t('layout.sidebar.linksNavigation.orderListAll') }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .sidebar {
    position: fixed;
    width: 280px;
    min-height: 100vh;
    box-sizing: border-box;
    background-color: var(--secondary-background-color);
    box-shadow: 0 10px 20px 0 #e1e1e1;
    transition: all 0.2s;
    z-index: 200;
  }

  .sidebar > div {
    position: fixed;
    width: 280px;
    z-index: 200;
  }

  .collapsed {
    width: 60px;
  }

  .collapsed > div {
    width: 60px;
  }

  .sidebar:hover > .closeIcon {
    opacity: 1;
  }

  .sidebar.collapsed > .closeIcon {
    opacity: 1;
  }

  .closeIcon {
    position: fixed;
    top: 200px;
    left: 268px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    padding: 0;
    font-size: 1.5rem;
    color: var(--primary-text-color-white);
    background-color: var(--primary-color);
    border: none;
    border-radius: 100%;
    opacity: 0;
    cursor: pointer;
    transition-property: left, width, height, background-color, opacity;
    transition-duration: 0.2s;
    z-index: 250;
  }

  .closeIcon.collapsed {
    left: 50px;
    width: 20px;
    height: 20px;
  }

  .closeIcon:hover,
  .closeIcon:focus,
  .closeIcon:active {
    background-color: var(--secondary-color);
  }

  .header {
    padding: 20px;
  }

  .logo {
    position: relative;
    width: 280px;
    height: 120px;
    transition-property: width;
    transition-duration: 0.2s;
  }

  .logo > img {
    position: relative;
    top: 20px;
    left: calc(50% - 50px);
    width: 100px;
    height: 100px;
    transition-property: top, left, width, height;
    transition-duration: 0.2s;
  }

  .title {
    margin: 0;
    font-size: 2.5rem;
    font-weight: 900;
    text-align: center;
    line-height: 1.5;
    color: var(--tertiary-color);
  }

  .title > span {
    display: block;
  }

  .linkGroup {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    border-top: 1px solid #e3e3e3;
  }

  .categoryTitle {
    margin: 0;
    padding: 0;
    font-size: 1.3rem;
    color: var(--secondary-text-color);
    text-transform: uppercase;
  }

  .links {
    margin: 20px 0;
    padding: 0;
    list-style-type: none;
  }

  .links > li {
    margin: 10px 0;
    padding: 5px 0;
  }

  .link {
    display: flex;
    align-items: center;
    font-size: 1.3rem;
    font-weight: 600;
    color: inherit;
    text-transform: uppercase;
    text-decoration: none;
    transition: color 0.2s;
  }

  .linkIcon {
    width: 1.8rem;
    height: 1.8rem;
    margin-right: 10px;
    font-size: 1.8rem;
    color: var(--tertiary-text-color);
    transition: inherit;
  }

  .link.active,
  .link.active > .linkIcon,
  .link:active,
  .link:active > .linkIcon {
    color: var(--primary-color);
  }

  .link:hover,
  .link:focus,
  .link:hover > .linkIcon,
  .link:focus > .linkIcon {
    color: var(--secondary-color);
  }

  .title,
  .categoryTitle,
  .linkText {
    white-space: nowrap;
    overflow: hidden;
    transition: opacity 0.2s;
  }

  .collapsed .logo {
    width: 60px;
  }

  .collapsed .logo > img {
    top: 0;
    left: 0;
    width: 60px;
    height: 60px;
  }

  .collapsed .title,
  .collapsed .categoryTitle,
  .collapsed .linkText,
  .expanding .title,
  .expanding .categoryTitle,
  .expanding .linkText {
    width: 0;
    opacity: 0;
  }
</style>

<script>
  export default {
    props: [ 'user' ],
    data() {
      return {
        isExpanding: false
      }
    },
    methods: {
      isActive(pathname) {
        return window.location.pathname === pathname;
      },
      toggleSidebar() {
        this.isExpanding = true;
        setTimeout(() => {
          this.isExpanding = false;
        }, 200);

        this.$emit('sidebarChange');
      }
    }
  }
</script>
